import { Props_SnippetIconsText } from "./IconsText.props";

const IconsText = (props: Props_SnippetIconsText) => {
    const { iconsTextHeading, repeatable_iconsTextContentOptions, iconsTextCardOptions } = props;

    const iconsTextHeadingClass =  "snippet-icons-text__heading " + (iconsTextHeading?.visibility.value === "visible" ? "" : "snippet-icons-text__heading--hidden");
    const iconsTextCardOptionsClass = iconsTextCardOptions?.cardPerRow?.value === "3" ? "snippet-icons-text" : "snippet-icons-text snippet-icons-text--four";

    return (
        <section className={iconsTextCardOptionsClass}>
            <div className="snippet-icons-text__container">
               {iconsTextHeading?.text?.value && <h2 className={iconsTextHeadingClass}>
                    {iconsTextHeading.text.value}
                </h2>}

                <div className="snippet-icons-text__card-container">
                    {repeatable_iconsTextContentOptions.map((iconsText, index) =>  (
                            <div key={"card" + index} className="snippet-icons-text__card">
                                {iconsText?.image?.value && <figure className="snippet-icons-text__icon-container">
                                    <img
                                        loading="lazy"
                                        src={iconsText.image.value}
                                        alt=""
                                        className="snippet-icons-text__icon"
                                        height="150"
                                        width="150"
                                    ></img>
                                </figure>}
                                <div className="snippet-icons-text__info-container">
                                   {iconsText?.cardheading?.value && <h3 className="snippet-icons-text__card-heading">
                                        {iconsText.cardheading.value}
                                    </h3>}
                                   {iconsText?.text?.value && <p className="snippet-icons-text__text">
                                        {iconsText.text.value}
                                    </p>}
                                    {iconsText?.linkhref?.value && iconsText?.linktext?.value &&
                                    <a
                                        href={iconsText.linkhref.value}
                                        className="snippet-icons-text__link attrax-button"
                                        aria-label={iconsText.linktext.value}
                                    >
                                        {iconsText.linktext.value}
                                    </a>}
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default IconsText;
